import { render, staticRenderFns } from "./PreguntasTable.vue?vue&type=template&id=7dd7758d"
import script from "./PreguntasTable.vue?vue&type=script&lang=js"
export * from "./PreguntasTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports